// extracted by css-extract-rspack-plugin
export default {"container":"Wc5KXEM1dwAsSBTi","input":"VxkONa0e6aYNnzOQ"};